import { ActivatedRoute, Router } from "@angular/router";

export class NavigationUtils {
  static navigateCurrentRouteWithQueryParams(router:Router,
    activatedRoute:ActivatedRoute,
    queryParams:{[key:string]:any},
    queryParamsHandling:'merge' | 'preserve'|null = 'merge'
  ):void{
    router.navigate([], {
      relativeTo: activatedRoute,
      queryParams: queryParams,
      queryParamsHandling: queryParamsHandling
    });
  }


  static removeQueryParamFromCurrentRoute(
    router: Router,
    activatedRoute: ActivatedRoute,
    paramToRemove: string
  ): void {
    const currentParams = { ...activatedRoute.snapshot.queryParams };
    delete currentParams[paramToRemove];
    this.navigateCurrentRouteWithQueryParams(router, activatedRoute, currentParams,null);
  }

  static removeQueryParamsFromCurrentRoute(
    router: Router,
    activatedRoute: ActivatedRoute,
    paramsToRemove: string[]
  ): void {
    const currentParams = { ...activatedRoute.snapshot.queryParams };

    // Remove each param in the list
    paramsToRemove.forEach(param => {
      delete currentParams[param];
    });

    this.navigateCurrentRouteWithQueryParams(router, activatedRoute, currentParams, null);
  }

  static updateAndRemoveQueryParams(
    router: Router,
    activatedRoute: ActivatedRoute,
    paramToRemove: string,
    newParams?: { [key: string]: any }
  ): void {
    const currentParams = { ...activatedRoute.snapshot.queryParams };

    // Remove the specified param
    delete currentParams[paramToRemove];

    // Add/Update the new params
    if(newParams){
      Object.keys(newParams).forEach(key => {
        if (newParams[key] === null || newParams[key] === undefined) {
          delete currentParams[key]; // Clean it if null/undefined
        } else {
          currentParams[key] = newParams[key];
        }
      });
    }

    // Navigate with the updated params (NO merge because you already merged manually)
    this.navigateCurrentRouteWithQueryParams(router, activatedRoute, currentParams, null);
  }

  static removeDetailSegmentFromRoute(
    router: Router,
    activatedRoute: ActivatedRoute
  ): void {
    const currentPath = router.url;

    // Ensure that the path is not empty
    if (!currentPath) {
      console.error("No path available.");
      return;
    }

    // Split the path into segments
    const pathSegments = currentPath.split('/');

    // Check if there are enough segments and remove the last one (detail)
    if (pathSegments.length > 0) {
      const removedSegment = pathSegments.pop(); // Removes the last segment (the "detail" one)

      // Rebuild the path and navigate to the new path
      const newPath = pathSegments.join('/');

      // Navigate to the new path
      router.navigate([newPath], { relativeTo: activatedRoute });
    } else {
    }
  }

  static removeSegmentsByIndex(
    router: Router,
    activatedRoute: ActivatedRoute,
    segmentIndices: number[]
  ): void {
    const currentPath = router.url;
    // Ensure that the path is not empty
    if (!currentPath) {
      console.error("No path available.");
      return;
    }

    // Split the path into segments
    const pathSegments = currentPath.split('/');

    // Map the passed indices to the actual path segments, adjusting by -1 as per your requirement
    const actualIndices = segmentIndices.map(index => index - 1);

    // Sort the indices in descending order to avoid index shifting issues while removing segments
    actualIndices.sort((a, b) => b - a);

    // Remove the segments by their indices
    actualIndices.forEach(index => {
      if (index >= 0 && index < pathSegments.length) {
        const removedSegment = pathSegments.splice(index, 1)[0]; // Remove the segment at the specified index
      } else {
        console.error('Invalid segment index:', index);
      }
    });

    // Rebuild the path and navigate to the new path
    const newPath = pathSegments.join('/');
    // Navigate to the new path
    router.navigate([newPath], { relativeTo: activatedRoute });
  }
}
